// extracted by mini-css-extract-plugin
module.exports = {"main":"LinkAsButton_main__1mBnZ","extra-padding":"LinkAsButton_extra-padding__mBuFi"};